
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.457 13.826s-.044 0-.044-.044c0 0-.043-.13-.086-.346-.564-.044-2.08-.13-2.08-.13-.043 0-.043 0-.043-.044l-.044-.216.217-.564.043-.043 1.863-.26-.216-.823-.087-.087-.087-.866-.173-1.3s-.043-.347-.043-.78v-.736s0-.087-.044-.13c0-.044-.043-.044-.086-.044-.217 0-4.03-.433-4.03-.433l-1.516-.13H.958c-.044 0-.13 0-.174.043-.13.087-.216.174-.216.174H.48l-.043-.044v-.39c.087-.216.303-.91.52-.953.216 0 5.632-.216 5.632-.216a.093.093 0 00.087-.087c0-.737 0-3.12.78-4.203l.043-.043s.043 0 .043.043c.78 1.084.78 3.466.78 4.203 0 .043.044.087.087.087 0 0 5.416.216 5.632.216.217 0 .477.694.52.91v.347s0 .043-.043.043h-.087s-.086-.043-.216-.173c-.044-.044-.13-.044-.174-.044H14l-1.56.13s-3.813.434-4.03.434c-.042 0-.086 0-.086.043-.043.043-.043.13-.043.13v.737c0 .39-.043.78-.043.78l-.174 1.3-.086.866-.087.216-.173.824 1.863.26s.043 0 .043.043l.217.52-.044.26c0 .043-.043.043-.043.043s-1.56.087-2.08.13c0 .217-.086.347-.086.347l-.044.043h-.086v-.043z"}})])
          )
        }
      }
    